const LOGO_URL = 'https://storage.readdy-site.link/project_files/631a32e5-64ad-4b7f-9425-a4311af1ac5d/489447e0-737c-4cbe-9c4f-314d2065be72_shadowfax-logo.webp?v=d8a20a74b4bef28b4f74cdde96a08adc';

function FooterLogo() {
  return (
    <img
      src={LOGO_URL}
      alt="Shadowfax Roofing & Solar"
      className="w-auto object-contain block"
      style={{ height: '48px' }}
    />
  );
}

const serviceLinks = [
  'Roof Replacement',
  'Roof Repair',
  'Solar Installation',
  'Gutter Replacement & Screens',
  'Battery Systems',
  'Flat & Metal Roofing',
  'Skylight Replacement',
];

const serviceAreas = ['Campbell', 'San Jose', 'Santa Clara', 'Mountain View', 'Palo Alto', 'Los Altos', 'Milpitas'];

export default function Footer() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer style={{ background: '#ffffff' }}>

      {/* Pre-footer CTA bar */}
      <div style={{ borderBottom: '1px solid #e8e8e4' }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-8 flex flex-col sm:flex-row items-center justify-between gap-6">
          <h4
            className="text-[#1a1a1a] text-xl font-black"
            style={{ fontFamily: "'Montserrat', sans-serif" }}
          >
            Talk to us today!
          </h4>
          <div className="flex flex-col sm:flex-row items-center gap-4">
            <button
              onClick={() => handleNav('#contact')}
              className="text-[#1a1a1a] font-bold text-xs px-8 py-3 rounded transition-all duration-300 cursor-pointer whitespace-nowrap uppercase tracking-[2px]"
              style={{ fontFamily: "'Montserrat', sans-serif", background: '#d4af37' }}
              onMouseEnter={e => (e.currentTarget.style.background = '#c4a030')}
              onMouseLeave={e => (e.currentTarget.style.background = '#d4af37')}
            >
              Get a Free Estimate
            </button>
            <a
              href="tel:4086280065"
              className="flex items-center gap-3 text-[#1a1a1a] hover:text-[#d4af37] transition-colors duration-300 whitespace-nowrap"
            >
              <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#d4af37]/10">
                <i className="ri-phone-line text-[#d4af37]"></i>
              </div>
              <div>
                <p className="text-[#999] text-[10px] uppercase tracking-wider" style={{ fontFamily: "'Montserrat', sans-serif" }}>Call Now</p>
                <p className="font-bold text-base text-[#1a1a1a]" style={{ fontFamily: "'Montserrat', sans-serif" }}>(408) 628-0065</p>
              </div>
            </a>
          </div>
        </div>
      </div>

      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16" style={{ borderTop: '1px solid #e8e8e4' }}>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">

          {/* Brand */}
          <div className="lg:col-span-1">
            <a
              href="#home"
              onClick={(e) => { e.preventDefault(); handleNav('#home'); }}
              className="inline-block mb-6 cursor-pointer"
            >
              <FooterLogo />
            </a>

            <div className="mb-5">
              <p
                className="text-[#999] text-[10px] uppercase tracking-[2px] mb-2"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                Business Hours
              </p>
              <p className="text-[#555] text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>Mon – Sat: 7:00 am – 6:00 pm</p>
              <p className="text-[#555] text-sm" style={{ fontFamily: "'Inter', sans-serif" }}>Sunday: Closed</p>
            </div>

            <div className="mb-6">
              <p
                className="text-[#999] text-[10px] uppercase tracking-[2px] mb-2"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                Address
              </p>
              <p className="text-[#555] text-sm leading-relaxed" style={{ fontFamily: "'Inter', sans-serif" }}>
                2959 Winchester Blvd Ste 102a<br />
                Campbell, CA 95008
              </p>
            </div>

            {/* Socials */}
            <div className="flex items-center gap-3">
              <a
                href="https://facebook.com/shadowfaxroofing/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full transition-all duration-300"
                style={{ border: '1px solid #e8e8e4', color: '#999' }}
                onMouseEnter={e => { (e.currentTarget as HTMLElement).style.borderColor = '#d4af37'; (e.currentTarget as HTMLElement).style.color = '#d4af37'; }}
                onMouseLeave={e => { (e.currentTarget as HTMLElement).style.borderColor = '#e8e8e4'; (e.currentTarget as HTMLElement).style.color = '#999'; }}
              >
                <i className="ri-facebook-fill text-sm"></i>
              </a>
              <a
                href="https://yelp.com/biz/shadowfax-roofing-and-solar-san-jose-3"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full transition-all duration-300"
                style={{ border: '1px solid #e8e8e4', color: '#999' }}
                onMouseEnter={e => { (e.currentTarget as HTMLElement).style.borderColor = '#d4af37'; (e.currentTarget as HTMLElement).style.color = '#d4af37'; }}
                onMouseLeave={e => { (e.currentTarget as HTMLElement).style.borderColor = '#e8e8e4'; (e.currentTarget as HTMLElement).style.color = '#999'; }}
              >
                <i className="ri-star-fill text-sm"></i>
              </a>
              <a
                href="https://maps.app.goo.gl/ZwKxPdNcsBzvZVGu8"
                target="_blank"
                rel="noopener noreferrer"
                className="w-9 h-9 flex items-center justify-center rounded-full transition-all duration-300"
                style={{ border: '1px solid #e8e8e4', color: '#999' }}
                onMouseEnter={e => { (e.currentTarget as HTMLElement).style.borderColor = '#d4af37'; (e.currentTarget as HTMLElement).style.color = '#d4af37'; }}
                onMouseLeave={e => { (e.currentTarget as HTMLElement).style.borderColor = '#e8e8e4'; (e.currentTarget as HTMLElement).style.color = '#999'; }}
              >
                <i className="ri-google-fill text-sm"></i>
              </a>
            </div>
          </div>

          {/* Services */}
          <div>
            <h4
              className="text-[#1a1a1a] font-bold text-[11px] uppercase tracking-[2.5px] mb-6"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Services
            </h4>
            <ul className="flex flex-col gap-3">
              {serviceLinks.map((link) => (
                <li key={link}>
                  <button
                    onClick={() => handleNav('#services')}
                    className="text-[#666] hover:text-[#d4af37] text-sm transition-colors duration-300 cursor-pointer flex items-start gap-2 text-left"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    <div className="w-3 h-3 flex items-center justify-center mt-0.5 flex-shrink-0">
                      <i className="ri-arrow-right-s-line text-[#d4af37] text-xs"></i>
                    </div>
                    {link}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Quick Links */}
          <div>
            <h4
              className="text-[#1a1a1a] font-bold text-[11px] uppercase tracking-[2.5px] mb-6"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Quick Links
            </h4>
            <ul className="flex flex-col gap-3">
              {[
                { label: 'Areas We Serve', target: '#service-areas' },
                { label: 'Client Reviews', target: '#testimonials' },
                { label: 'FAQs', target: '#faq' },
                { label: 'Contact Us', target: '#contact' },
              ].map((item) => (
                <li key={item.label}>
                  <button
                    onClick={() => handleNav(item.target)}
                    className="text-[#666] hover:text-[#d4af37] text-sm transition-colors duration-300 cursor-pointer flex items-center gap-2 whitespace-nowrap"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    <div className="w-3 h-3 flex items-center justify-center">
                      <i className="ri-arrow-right-s-line text-[#d4af37] text-xs"></i>
                    </div>
                    {item.label}
                  </button>
                </li>
              ))}
            </ul>

            <div className="mt-8">
              <h4
                className="text-[#1a1a1a] font-bold text-[11px] uppercase tracking-[2.5px] mb-4"
                style={{ fontFamily: "'Montserrat', sans-serif" }}
              >
                Service Areas
              </h4>
              <div className="flex flex-wrap gap-x-3 gap-y-2">
                {serviceAreas.map((area) => (
                  <span
                    key={area}
                    className="text-[#666] text-xs flex items-center gap-1"
                    style={{ fontFamily: "'Inter', sans-serif" }}
                  >
                    <i className="ri-map-pin-line text-[#d4af37] text-xs"></i>
                    {area}
                  </span>
                ))}
              </div>
            </div>
          </div>

          {/* Map */}
          <div>
            <h4
              className="text-[#1a1a1a] font-bold text-[11px] uppercase tracking-[2.5px] mb-6"
              style={{ fontFamily: "'Montserrat', sans-serif" }}
            >
              Get Directions
            </h4>
            <div className="rounded-lg overflow-hidden mb-4" style={{ height: '180px' }}>
              <iframe
                title="Shadowfax Roofing & Solar location map"
                src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d396.8801294675499!2d-121.955651!3d37.270454!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x808e3504dd99fa9d%3A0xb62bb9bce59a526c!2s2959%20Winchester%20Blvd%20%23102a%2C%20Campbell%2C%20CA%2095008!5e0!3m2!1sen!2sus!4v1769073377416!5m2!1sen!2sus"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
            <a
              href="https://maps.app.goo.gl/ZwKxPdNcsBzvZVGu8"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 text-[#d4af37]/70 hover:text-[#d4af37] text-xs transition-colors duration-300"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              <i className="ri-external-link-line text-xs"></i>
              Open in Google Maps
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div style={{ borderTop: '1px solid #e8e8e4' }}>
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#aaa] text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
            &copy; {new Date().getFullYear()} Shadowfax Roofing &amp; Solar &mdash; All Rights Reserved
          </p>
          <p className="text-[#aaa] text-xs" style={{ fontFamily: "'Inter', sans-serif" }}>
            Licensed &amp; Insured &middot; Campbell, CA &middot; Serving the South Bay
          </p>
        </div>
      </div>
    </footer>
  );
}
